import { useCallback } from "react";
import { usePapaParse } from "react-papaparse";

type KeyList<T> = (keyof T & string)[];

export function useCsvExport<T extends Record<string, any>>(
	rows: T[],
	keys: KeyList<T>,
) {
	const { jsonToCSV } = usePapaParse();
	return useCallback(
		(filename: string) => {
			if (!rows.length || !keys.length) return;

			const flatRows: Record<string, any>[] = rows.map((row) => {
				const out: Record<string, any> = {};
				for (const key of keys) {
					const val = row[key].value;
					out[key] = val == null ? "" : val;
				}
				return out;
			});

			const csv = jsonToCSV(flatRows, {
				header: true,
				skipEmptyLines: true,
			});

			console.info(csv);

			const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
			const url = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;

			link.click();
			URL.revokeObjectURL(url);
		},
		[rows, keys, jsonToCSV],
	);
}
